import Paper from '@material-ui/core/Paper';

/** @deprecated Exporting the Paper component from the Material-UI library. */
export default Paper;
